import { render, staticRenderFns } from "./WorkspaceReorganizeModal.vue?vue&type=template&id=422772f2&scoped=true"
import script from "./WorkspaceReorganizeModal.vue?vue&type=script&lang=js"
export * from "./WorkspaceReorganizeModal.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceReorganizeModal.vue?vue&type=style&index=0&id=422772f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422772f2",
  null
  
)

export default component.exports